/**
 * @readonly
 * @enum {string}
 */
export const TachographTypes = Object.freeze({
    ACTIA: 'STAC',
    EFAS: 'EFAS',
    STONERIDGE: 'STR',
    UNKNOWN: 'UNKNOWN',
    VDO: 'DTCO'
})
